// src/components/awards/AwardSelectionInfoModal.js
import React, { memo } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const AwardSelectionInfoModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Awards may be selected by:
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ my: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Committee:
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            A Committee consisting of school and community members meet to
            review and select the majority of the awards offered.
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            School:
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            School specific awards are selected by school representatives.
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Donor:
          </Typography>
          <Typography variant="body1">
            Awards requiring additional information such as an application or
            letter/essay are reviewed and selected by donor.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(AwardSelectionInfoModal);
